import React, { useState, useEffect } from "react";
import { Dropdown, Row, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";

import PageTitle from "../../layouts/PageTitle";
import { IMAGES } from "../../constant/theme";
import { getCustomersApi } from "../../../services/CustomerService";

const theadData = [
  { heading: "Profile", sortingVale: "profile" },
  { heading: "Name", sortingVale: "name" },
  { heading: "Mobile", sortingVale: "mobile" },
  { heading: "Email", sortingVale: "email" },
  { heading: "Wallet Balance", sortingVale: "walletBalance" },
  { heading: "Joining Date", sortingVale: "join" },
];

const sortFieldMap = {
  name: "name",
  mobile: "phone",
  email: "email",
  join: "createdAt",
};

const AllCustomers = () => {
  const [sort, setSortata] = useState(10);
  const [isLoading, setIsLoading] = useState(false);

  const [customers, setCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortBy] = useState("updatedAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm.trim());
      setPage(1);
    }, 350);
    return () => clearTimeout(timeout);
  }, [searchTerm]);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        setIsLoading(true);
        const response = await getCustomersApi({
          page,
          limit: Number(sort),
          search: debouncedSearchTerm,
          sortBy,
          sortOrder,
        });

        const users = Array.isArray(response?.data?.data) ? response.data.data : [];
        const pagination = response?.data?.pagination || {};

        const mapped = users.map((item) => ({
          id: item.id || item._id,
          name: item.name || "-",
          profile: item.profileImageUrl || IMAGES.smallpic1,
          mobile: item.phone || "-",
          email: item.email || "-",
          walletBalance: item.walletBalance ?? 0,
          join: item.createdAt
            ? new Date(item.createdAt).toLocaleDateString("en-IN")
            : "-",
        }));

        setCustomers(mapped);
        setTotal(Number(pagination.total) || 0);
        setTotalPages(Number(pagination.totalPages) || 1);
      } catch (_error) {
        setCustomers([]);
        setTotal(0);
        setTotalPages(1);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCustomers();
  }, [page, sort, debouncedSearchTerm, sortBy, sortOrder]);

  const onSort = (sortingVale, ind) => {
    const backendField = sortFieldMap[sortingVale];
    if (!backendField) return;

    const nextOrder = sortBy === backendField && sortOrder === "asc" ? "desc" : "asc";
    setSortBy(backendField);
    setSortOrder(nextOrder);
    setPage(1);
    setIconDate({ complete: nextOrder === "asc", ind });
  };

  const paggination = Array(totalPages).fill().map((_, i) => i + 1);
  const showingFrom = total > 0 ? (page - 1) * Number(sort) + 1 : 0;
  const showingTo = total > 0 ? Math.min(page * Number(sort), total) : 0;

  return (
    <>
      <PageTitle activeMenu="All Customers" motherMenu="Customers" />
      <Row>
        <Tab.Container defaultActiveKey="List">
          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">All Customer List</h4>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div id="customerList" className="dataTables_wrapper no-footer">
                        <div className="justify-content-between d-sm-flex">
                          <div className="dataTables_length">
                            <label className="d-flex align-items-center">
                              Show
                              <Dropdown className="search-drop">
                                <Dropdown.Toggle as="div" className="search-drop-btn">
                                  {sort}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item onClick={() => { setSortata(10); setPage(1); }}>10</Dropdown.Item>
                                  <Dropdown.Item onClick={() => { setSortata(20); setPage(1); }}>20</Dropdown.Item>
                                  <Dropdown.Item onClick={() => { setSortata(30); setPage(1); }}>30</Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                              entries
                            </label>
                          </div>
                          <div className="dataTables_filter">
                            <label>
                              Search:{" "}
                              <input
                                type="search"
                                className=""
                                placeholder=""
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                              />
                            </label>
                          </div>
                        </div>
                        <table id="example4" className="display dataTable no-footer w-100">
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th key={ind} onClick={() => onSort(item.sortingVale, ind)}>
                                  {item.heading}
                                  <span>
                                    {ind !== iconData.ind && (
                                      <i className="fa fa-sort ms-2 fs-12" style={{ opacity: "0.3" }} />
                                    )}
                                    {ind === iconData.ind && (
                                      iconData.complete
                                        ? <i className="fa fa-arrow-down ms-2 fs-12" style={{ opacity: "0.7" }} />
                                        : <i className="fa fa-arrow-up ms-2 fs-12" style={{ opacity: "0.7" }} />
                                    )}
                                  </span>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {isLoading && (
                              <tr><td colSpan={6}>Loading customers...</td></tr>
                            )}
                            {!isLoading && customers.length === 0 && (
                              <tr><td colSpan={6}>No customers found</td></tr>
                            )}
                            {customers.map((item, ind) => (
                              <tr key={item.id || ind}>
                                <td>
                                  <img
                                    className="rounded-circle"
                                    width="35"
                                    src={item.profile}
                                    alt=""
                                  />
                                </td>
                                <td style={{ textTransform: "capitalize" }}>{item.name}</td>
                                <td>
                                  <Link to="#">
                                    <strong>{item.mobile}</strong>
                                  </Link>
                                </td>
                                <td>
                                  <Link to="#">
                                    <strong>{item.email}</strong>
                                  </Link>
                                </td>
                                <td>₹{Number(item.walletBalance).toFixed(2)}</td>
                                <td>{item.join}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            Showing {showingFrom} to {showingTo} of {total} entries
                          </div>
                          <div
                            className="dataTables_paginate paging_simple_numbers"
                            id="example5_paginate"
                          >
                            <Link
                              className={`paginate_button previous ${page <= 1 ? "disabled" : ""}`}
                              to="#"
                              onClick={() => page > 1 && setPage(page - 1)}
                            >
                              Previous
                            </Link>
                            <span>
                              {paggination.map((number, i) => (
                                <Link
                                  key={i}
                                  to="#"
                                  className={`paginate_button ${page === number ? "current" : ""}`}
                                  onClick={() => setPage(number)}
                                >
                                  {number}
                                </Link>
                              ))}
                            </span>
                            <Link
                              className={`paginate_button next ${page >= totalPages ? "disabled" : ""}`}
                              to="#"
                              onClick={() => page < totalPages && setPage(page + 1)}
                            >
                              Next
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>
    </>
  );
};

export default AllCustomers;
